var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6562 3.0625H1.53125C1.15829 3.0625 0.800604 3.21066 0.536881 3.47438C0.273158 3.7381 0.125 4.09579 0.125 4.46875V12.3438C0.125 12.7167 0.273158 13.0744 0.536881 13.3381C0.800604 13.6018 1.15829 13.75 1.53125 13.75H11.6562C12.0292 13.75 12.3869 13.6018 12.6506 13.3381C12.9143 13.0744 13.0625 12.7167 13.0625 12.3438V4.46875C13.0625 4.09579 12.9143 3.7381 12.6506 3.47438C12.3869 3.21066 12.0292 3.0625 11.6562 3.0625ZM11.375 12.0625H1.8125V4.75H11.375V12.0625ZM15.875 1.65625V10.375C15.875 10.5988 15.7861 10.8134 15.6279 10.9716C15.4696 11.1299 15.255 11.2188 15.0312 11.2188C14.8075 11.2188 14.5929 11.1299 14.4346 10.9716C14.2764 10.8134 14.1875 10.5988 14.1875 10.375V1.9375H3.5C3.27622 1.9375 3.06161 1.84861 2.90338 1.69037C2.74514 1.53214 2.65625 1.31753 2.65625 1.09375C2.65625 0.869974 2.74514 0.655362 2.90338 0.497129C3.06161 0.338895 3.27622 0.25 3.5 0.25H14.4688C14.8417 0.25 15.1994 0.398158 15.4631 0.661881C15.7268 0.925604 15.875 1.28329 15.875 1.65625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsIcon);
export default __webpack_public_path__ + "static/media/cardsIcon.a37239c5f787f3ba192bb19b235a96e6.svg";
export { ForwardRef as ReactComponent };